export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  RESETPASSWORD: '/resetPassword',
  PROFILE: '/profile',
  FEEDBACK: '/feedback',
  FILE: '/file',
} as const;

export const PUBLIC_ROUTES = [ROUTES.LOGIN, ROUTES.REGISTER] as const; 